<template>
    <div class="confirmation">
        <div class="confirmation_description" v-html="(isCallMode) ? loc.CT_BSAC_CONFIRM_DESC_CALL.replace('#LENGTH#', codeLength) : loc.CT_BSAC_CONFIRM_DESC "></div>
        <div class="messages-block"
             :class="error ? 'error' : 'success'"
             v-if="message">
            <span v-html="message"></span>
        </div>
        <div class="confirmation_wrap">
            <template v-for="field in formFields" v-if="!success">
                <form-field-phone
                    v-if="field.TYPE == 'phone'"
                    ref="field"
                    input-class="input"
                    :field-props="field"
                    :value="field.VALUE"
                    v-model="field.VALUE"
                ></form-field-phone>
                <form-field-email
                    v-else-if="field.TYPE == 'email'"
                    ref="field"
                    input-class="input"
                    :field-props="field"
                    :value="field.VALUE"
                    v-model="field.VALUE"
                ></form-field-email>
                <form-field-text
                    v-else
                    ref="field"
                    input-class="input"
                    :field-props="field"
                    :value="field.VALUE"
                    v-model="field.VALUE"
                ></form-field-text>
            </template>
        </div>
        <div class="confirmation_wrap-btn" v-if="allowRequestBlock">
            <template v-if="!allowRequestBtn">
                <span v-html="redirectText"></span>
            </template>
            <template v-else>
                <a href="javascript:void(0)"
                   class="confirmation_link--replace"
                   v-if="canRegenerateConfirmCode"
                   v-html="loc.CT_BSAC_GET_CONFIRM_CALL"
                   @click="confirmCodeRegenerate('call')"></a>
                <a href="javascript:void(0)"
                   class="confirmation_link--replace"
                   v-if="canRegenerateConfirmCode"
                   v-html="loc.CT_BSAC_GET_CONFIRM"
                   @click="confirmCodeRegenerate('sms')"></a>
            </template>
        </div>
        <div class="form__group form__flex--submit">
            <button class="button button__primary"
                    :class="{loading: loading}"
                    v-html="loc.CT_BSAC_CONFIRM"
                    @click="ajaxRequest"
            >
            </button>
        </div>
    </div>
</template>
<script>
import {Vue} from "ui.vue";

export default {
    name: 'Confirmation',
    props: {
        user: {
            type: [String, Number],
            required: true,
        },
        type: {
            type: String,
            default: 'ID',//'ID' or 'LOGIN'
        },
        _error: {
            type: Boolean,
            default: false
        },
        _message: {
            type: [String, Boolean],
            default: ''
        },
        /**
         * Нужно ли после успешного подтверждения авторизовать пользователя и редиректить в ЛК
         */
        doAuthorize: {
            type: Boolean,
            default: false
        },
        /**
         * Включен режим подтверждения по звонку
         */
        isCallMode: {
            type: Boolean,
            default: false
        },
        /**
         * Длина кода подтверждения. Используется для вывода текста при звонке
         */
        codeLength: {
            type: Number,
            default: 0
        },
        defaultCanRegenerate: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            loading: false,
            error: false,
            success: false,
            message: '',
            canRegenerateConfirmCode: false,
            userField: {
                ROW_CLASS: 'form__group',
                ID: 'login',
                NAME: '',
                TITLE: '',
                CODE: 'login',
                TYPE: 'text',
                REQUIRED: 'Y',
                VALUE: '',
                HIDDEN: 'Y',
            },
            confirmField: {
                ROW_CLASS: 'form__group',
                ID: 'confirm_code',
                NAME: '',
                TITLE: '',
                CODE: 'confirm_code',
                TYPE: 'text',
                REQUIRED: 'Y',
                VALUE: ''
            },
            doAuthorizeField: {
                ROW_CLASS: 'form__group',
                ID: 'do_authorize',
                NAME: '',
                TITLE: '',
                CODE: 'do_authorize',
                TYPE: 'text',
                REQUIRED: 'N',
                VALUE: 'Y',
                HIDDEN: 'Y'
            },
            backurl: '',
            timer: 30,
            allowRequestBtn: false,
            allowRequestBlock: false,
        }
    },
    watch: {
        user(newVal) {
            this.userField['VALUE'] = newVal;
        },
    },
    computed: {
        redirectText() {
            return 'Повторно запросить код можно через ' + this.timer + ' сек.'
        },
        loc() {
            return Vue.getFilteredPhrases("CT_BSAC_");
        },

        formFields() {
            let fields = [];
            fields.push(this.userField);
            fields.push({
                ID: 'type',
                NAME: '',
                TITLE: '',
                CODE: 'type',
                TYPE: 'text',
                REQUIRED: 'N',
                VALUE: this.type,
                HIDDEN: 'Y',
            });
            if (this.doAuthorize) {
                fields.push(this.doAuthorizeField);
            }

            fields.push(this.confirmField);

            return fields;
        }
    },
    created() {
        this.error = this._error;
        this.message = this._message;
        this.canRegenerateConfirmCode = this.defaultCanRegenerate;
        this.userField.VALUE = this.user;
        this.confirmField.NAME = this.isCallMode ? this.loc.CT_BSAC_CONFIRM_CODE_CALL.replace('#LENGTH#', this.codeLength) : this.loc.CT_BSAC_CONFIRM_CODE;
        this.confirmField.TITLE = this.confirmField.NAME;

	    this.onShowAllowRequestBlock()
    },
    methods: {
        onShowAllowRequestBlock: function() {
            this.timer = 30
            this.allowRequestBlock = true
            this.allowRequestBtn = false

            let limit = this.timer
            // повторить с интервалом 2 секунды
            let timerId = setInterval(() => {
                this.timer--
            }, 1000);
            setTimeout(() => { clearInterval(timerId); this.allowRequestBtn = true; }, limit * 1000);
        },
        resetConfirmCode() {
            for (let field of this.formFields) {
                if (field.CODE == 'confirm_code') {
                    field.VALUE = '';
                    break;
                }
            }
        },
        ajaxRequest: async function () {
            if (this.loading)
                return;

            let isValid = await this.isValidate();
            if (!isValid) {
                return;
            }

            this.setDefault();
            let data = {};
            for (let field of this.formFields) {
                data[field.CODE] = field.VALUE;
            }

            this.loading = true;
            BX.ajax.runComponentAction('citrus:system.auth.actions', 'confirmation', {
                mode: 'class',
                data: data
            })
                .then((response) => {
                    this.loading = false;
                    let message = response.data && response.data.hasOwnProperty('message') && response.data.message ? response.data.message : false;
                    if (response && response.data && response.data.hasOwnProperty('success') && response.data.success === true) {
                        this.success = true;
                        if (message) {
                            this.message = message;
                        }
                        this.$emit("success", response.data);
                    } else {
                        this.error = true;
                        this.message = message ? message : this.loc.CT_BSAC_UNKNOWN_ERROR_MESSAGE;
                        this.canRegenerateConfirmCode = true;
                        this.$emit("error", response.data);
                    }

                }).catch((response) => {
                    this.onShowAllowRequestBlock()
                    this.message = response && response.errors && response.errors.length > 0 ? response.errors[0].message : this.loc.CT_BSAC_UNKNOWN_ERROR_MESSAGE;
                    this.error = true;
                    this.canRegenerateConfirmCode = true;
                    this.loading = false;
                    this.$emit("error", response.errors);
            });
        },
        isValidate: async function (component) {
            let isValid = true,
                val = null;
            if (!component)
                component = this;

            if (component.$refs.hasOwnProperty('field')) {
                for (let field of component.$refs.field) {
                    val = await field.checkValid();
                    if (!val) {
                        isValid = false;
                    }
                }
            }

            if (component.$refs.hasOwnProperty('group')) {
                for (let group of component.$refs.group) {
                    let isValidGroup = await this.isValidate(group);
                    if (!isValidGroup)
                        isValid = false;
                }
            }

            return isValid;
        },
        setDefault: function () {
            this.error = false;
            this.success = false;
            this.message = '';
            this.canRegenerateConfirmCode = this.defaultCanRegenerate;
        },
        confirmCodeRegenerate: function (notice) {
            this.onShowAllowRequestBlock()

            if (this.loading)
                return;

            this.setDefault();
            this.loading = true;

            let data = {
	            notice
            };

            for (let field of this.formFields) {
                data[field.CODE] = field.VALUE;
            }

            BX.ajax.runComponentAction('citrus:system.auth.actions', 'sendConfirmCode', {
                mode: 'class',
                data: data
            })
                .then((response) => {
                    let message = response.data && response.data.hasOwnProperty('message') && response.data.message ? response.data.message : false;
                    if (response && response.data && response.data.hasOwnProperty('success') && response.data.success) {
                        if (message)
                            this.message = message;
                    } else {
                        this.error = true;
                        this.message = message ? message : this.loc.CT_BSAC_UNKNOWN_ERROR_MESSAGE;
                    }

                    if (response.data.hasOwnProperty("backurl")) {
                        BX.reload(response.data.backurl);
                    }

                    this.loading = false;
                    this.resetConfirmCode();
                }).catch((response) => {
                this.message = response && response.errors && response.errors.length > 0 ? response.errors[0].message : this.loc.CT_BSAC_UNKNOWN_ERROR_MESSAGE;
                this.error = true;
                this.loading = false;
                this.resetConfirmCode();
            });
        }
    },
};
</script>
